import { callApi } from '@/utils/callApi';

import { requestCreators } from './requestCreators';

export async function fetcher(url, ...requestArgs) {
  const requestCreator = requestCreators[url];
  const requestParams =
    typeof requestCreator === 'function'
      ? requestCreator(...requestArgs)
      : {
          method: 'GET',
        };

  const { data } = await callApi({
    url,
    ...requestParams,
  });

  return data;
}
